/* src/app/features/limite-pagamento-ecg-por-terceiros/pesquisa/limite-pagamento-ecg-por-terceiros-pesquisa/listagem/limite-pagamento-ecg-por-terceiros-listagem/limite-pagamento-ecg-por-terceiros-listagem.component.scss */
.italico-e-verde {
  font-style: italic;
  color: #03974A;
}
/*# sourceMappingURL=limite-pagamento-ecg-por-terceiros-listagem.component.css.map */
